module.exports = __webpack_public_path__ + "img/eg13.12b74e81.png";